<template>
  <div class="history-page">
    <section class="history-hero" :style="heroStyle">
      <div class="history-hero-overlay"></div>
      <div class="container history-hero-content">
        <div v-reveal class="history-hero-copy">
          <p>{{ heroTag }}</p>
          <h1>{{ heroTitle }}</h1>
          <span>{{ breadcrumbText }}</span>
        </div>
      </div>
    </section>

    <section class="history-timeline-section" :style="timelineStyle">
      <div class="history-timeline-overlay"></div>
      <div class="container history-timeline-shell">
        <aside class="history-side" v-reveal>
          <div class="history-side-card">
            <div class="history-side-en">DEVELOPMENT</div>
            <h2 style="font-size: 48px">{{ sideTitle }}</h2>
            <p v-for="paragraph in introParagraphs" :key="$pick(paragraph)">
              {{ $pick(paragraph) }}
            </p>
          </div>
        </aside>

        <div class="history-main">
          <article
            v-for="(item, index) in timeline"
            :key="item.year"
            class="history-row"
            :style="{ transitionDelay: index * 140 + 'ms' }"
            v-reveal
          >
            <div class="history-dot"></div>
            <div class="history-desc">{{ $pick(item.text) }}</div>
            <div class="history-year">{{ item.year }}</div>
          </article>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "DevelopmentHistoryPage",
  computed: {
    heroStyle() {
      return {
        backgroundImage:
          "linear-gradient(180deg, rgba(18, 38, 18, 0.28), rgba(18, 38, 18, 0.42)), url('/history/hero.jpg')"
      };
    },
    timelineStyle() {
      return {
        backgroundImage:
          "linear-gradient(180deg, rgba(245, 248, 252, 0.92), rgba(247, 249, 252, 0.94)), url('/history/timeline-bg.jpg')"
      };
    },
    heroTag() {
      return this.locale === "zh-CN" ? "ABOUT HONGBANG" : "ABOUT HONGBANG";
    },
    heroTitle() {
      return this.locale === "zh-CN" ? "发展历程" : "Development History";
    },
    breadcrumbText() {
      return this.locale === "zh-CN"
        ? "首页 > 关于宏邦 > 发展历程"
        : "Home > About > Development History";
    },
    sideTitle() {
      return this.locale === "zh-CN"
        ? "稳步成长，持续扩张"
        : "Steady Growth and Continuous Expansion";
    },
    introParagraphs() {
      return [
        {
          "zh-CN":
            "江苏宏邦变压器有限公司自创建以来，持续围绕输配电装备、新能源配套、工业电力系统和国际市场业务进行能力提升，逐步形成稳定的制造基础与规模化交付能力。",
          "en-US":
            "Since its establishment, Jiangsu Hongbang Transformer Co., Ltd. has continued to strengthen its capabilities in transmission equipment, renewable support systems, industrial power supply and international markets."
        },
        // {
        //   "zh-CN":
        //     "以下时间节点用于展示企业在扩建园区、产线升级、销售突破和重大项目落地方面的发展路径，整体结构参考官网发展历程页面，后续你也可以继续补充更多年份与真实节点。",
        //   "en-US":
        //     "The timeline below presents milestones in campus expansion, line upgrades, sales growth and major project implementation, and can be extended later with more real yearly records."
        // }
      ];
    },
    timeline() {
      return [
        {
          year: "2026",
          text: {
            "zh-CN": "宏邦规划智能新厂区, 正式开工蓄力产能升级",
            "en-US": "Hongbang plans to launch a new smart factory, officially commencing construction to upgrade production capacity."
          }
        },
        {
          year: "2025",
          text: {
            "zh-CN": "聚焦节能配电技术创新，完成8款变压器向高能效、低损耗迭代升级。",
            "en-US": "Focusing on innovation in energy-saving power distribution technology, we have completed iterative upgrades of 8 transformers to achieve higher energy efficiency and lower losses."
          }
        },
        {
          year: "2024",
          text: {
            "zh-CN": "扩大工厂面积至5.8万平方米，新建两个变压器车间，公司销售业绩超30亿元。",
            "en-US": "The company expanded its factory area to 58,000 square meters and built two new transformer workshops. The company's sales performance exceeded 3 billion yuan."
          }
        },
        {
          year: "2023",
          text: {
            "zh-CN": "2023年，建立全流程严格质量管控体系，产品通过多项专业检测。",
            "en-US": "In 2023, We have established a rigorous quality control system throughout the entire process, and our products have passed multiple professional tests."
          }
        },
        {
          year: "2022",
          text: {
            "zh-CN": "江苏宏邦变压器有限公司正式成立，建成标准化现代化生产基地。",
            "en-US": "In 2022, Jiangsu Hongbang Transformer Co., Ltd. was officially established, and a standardized and modern production base was built."
          }
        },
      ];
    }
  }
};
</script>

<style scoped>
.history-page {
  background: #ffffff;
}

.history-hero {
  position: relative;
  min-height: 720px;
  padding-top: 148px;
  color: #ffffff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.history-hero-overlay {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.1), transparent 22%),
    linear-gradient(180deg, rgba(22, 34, 19, 0.22), rgba(22, 34, 19, 0.38));
}

.history-hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  min-height: 560px;
}

.history-hero-copy {
  padding-top: 120px;
}

.history-hero-copy p {
  margin: 0 0 18px;
  font-size: 14px;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  opacity: 0.92;
}

.history-hero-copy h1 {
  margin: 0 0 180px;
  font-size: clamp(50px, 5vw, 82px);
  line-height: 1.05;
}

.history-hero-copy span {
  color: rgba(255, 255, 255, 0.76);
  font-size: 15px;
}

.history-timeline-section {
  position: relative;
  overflow: hidden;
  margin-top: -76px;
  padding: 0 0 110px;
  background-position: center bottom;
  background-repeat: no-repeat;
  background-size: cover;
}

.history-timeline-overlay {
  position: absolute;
  inset: 0;
  background:
    linear-gradient(180deg, rgba(247, 249, 252, 0.68), rgba(247, 249, 252, 0.92)),
    linear-gradient(90deg, rgba(255, 255, 255, 0.06), transparent 30%, rgba(255, 255, 255, 0.05));
}

.history-timeline-shell {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: minmax(320px, 0.88fr) minmax(0, 1.52fr);
  align-items: stretch;
}

.history-side {
  position: relative;
}

.history-side-card {
  min-height: 100%;
  padding: 92px 52px 72px;
  color: #ffffff;
  background:
    linear-gradient(180deg, rgba(33, 62, 112, 0.16), rgba(26, 111, 203, 0.24)),
    linear-gradient(135deg, rgba(18, 79, 153, 0.82), rgba(26, 111, 203, 0.74) 56%, rgba(79, 100, 184, 0.62));
  backdrop-filter: blur(4px);
}

.history-side-en {
  margin-bottom: 18px;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2em;
}

.history-side-card h2 {
  margin: 0 0 28px;
  font-size: clamp(34px, 3vw, 52px);
  line-height: 1.18;
}

.history-side-card p {
  margin: 0 0 24px;
  font-size: 18px;
  line-height: 1.95;
  color: rgba(255, 255, 255, 0.92);
}

.history-main {
  position: relative;
  padding: 24px 0 0;
  background: rgba(244, 248, 252, 0.72);
  backdrop-filter: blur(4px);
}

.history-row {
  position: relative;
  display: grid;
  grid-template-columns: 26px 1fr auto;
  align-items: center;
  min-height: 118px;
  padding: 0 24px 0 0;
  border-top: 1px solid rgba(41, 131, 216, 0.72);
}

.history-row:last-child {
  border-bottom: 1px solid rgba(41, 131, 216, 0.72);
}

.history-dot {
  position: relative;
  width: 14px;
  height: 14px;
  margin-left: -7px;
  border-radius: 50%;
  background: #1db5dc;
  box-shadow: 0 0 0 6px rgba(29, 181, 220, 0.14);
}

.history-desc {
  padding: 0 28px 0 10px;
  color: #283444;
  font-size: 17px;
  line-height: 1.95;
}

.history-year {
  color: #2c88d5;
  font-size: clamp(34px, 3vw, 58px);
  font-weight: 500;
  line-height: 1;
  white-space: nowrap;
}

@media (max-width: 1200px) {
  .history-timeline-shell {
    grid-template-columns: 1fr;
  }

  .history-side-card {
    padding: 64px 32px 48px;
  }
}

@media (max-width: 900px) {
  .history-hero {
    min-height: 560px;
    padding-top: 126px;
  }

  .history-hero-copy {
    padding-top: 72px;
  }

  .history-hero-copy h1 {
    margin-bottom: 110px;
    font-size: 42px;
  }

  .history-timeline-section {
    margin-top: -38px;
    padding-bottom: 72px;
  }

  .history-side-card {
    padding: 44px 18px 34px;
  }

  .history-side-card p {
    font-size: 16px;
    line-height: 1.8;
  }

  .history-main {
    padding-top: 0;
  }

  .history-row {
    grid-template-columns: 22px 1fr;
    gap: 8px 0;
    padding: 18px 12px 18px 0;
  }

  .history-desc {
    grid-column: 2 / 3;
    padding: 0 0 0 6px;
    font-size: 15px;
    line-height: 1.8;
  }

  .history-year {
    grid-column: 2 / 3;
    padding-left: 6px;
    font-size: 32px;
  }
}

@media (max-width: 520px) {
  .history-hero {
    min-height: 420px;
    padding-top: 72px;
  }

  .history-hero-content {
    min-height: 340px;
  }

  .history-hero-copy {
    padding-top: 84px;
  }

  .history-hero-copy p {
    font-size: 12px;
    letter-spacing: 0.14em;
  }

  .history-hero-copy h1 {
    margin-bottom: 72px;
    font-size: 34px;
  }

  .history-hero-copy span {
    font-size: 13px;
    line-height: 1.6;
  }

  .history-side-card h2 {
    font-size: 28px;
  }

  .history-side-card p {
    font-size: 14px;
  }

  .history-row {
    min-height: auto;
  }
}
</style>
